import React from 'react';
// import * as Backend from '../../backend';
import * as util from '../../other/util.js';
import { Link } from "react-router-dom";
// import {Route} from "react-router";

// The root view for inspecting an owned planet
// It has the PlanetHeader on top and displays the different construction, ship, resource views below
class ArcView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        // let x = this.props.match.params.x;
        // let y = this.props.match.params.y;
        // let z = this.props.match.params.z;

        // Backend.getPlanetDetails(x, y, z, (res) => {
        //     if (res.planet.owner_id !== util.getGPS().player_id) {
        //         this.props.navigate('/game/solar-system' + util.getPlanetUrl(this.props.match.params));
        //         return;
        //     }
        //
        //     res.planet.stationed_ships = new ShipCollection(res.planet.stationed_ships);
        //     this.setState({planet: res.planet});
        // });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let planet = this.state.planet;
        // let page = this._getActivePage();

        return (
            <div>
                <h1>The Arc</h1>
                {/*<PlanetHeaderView planet={planet} activePage={page}/>*/}
                {/*<Route path="/game/planet-construction/:x/:y/:z" exact*/}
                {/*       render={(props) => <PlanetConstructionView {...props} planet={planet} onUpdatePlanet={(p) => {*/}
                {/*           this.onUpdatePlanet(p)*/}
                {/*       }}/>}/>*/}
                <Link className="link-button-menu" to={{ pathname: '/game/dashboard', force_update: true }}>Tavern</Link>
                <Link className="link-button-menu" to={{ pathname: '/game/dashboard', force_update: true }}>Merchants Guild</Link>
                <Link className="link-button-menu" to={{ pathname: '/game/dashboard', force_update: true }}>Military Quaters</Link>
                <Link className="link-button-menu" to={{ pathname: '/game/dashboard', force_update: true }}>Inventors</Link>

                <util.JsonDebug obj={planet} />
            </div>
        );
    }

    onUpdatePlanet(planet) {
        // this.setState({planet: planet});
    }

    // _getActivePage() {
    //     return this.props.location.pathname.split('/')[2];
    // }
}

export default util.withNavigation(ArcView);